import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CountryAPI} from "../../../../business/apis/CountryAPI";
import {BehaviorSubject} from "rxjs";
import {Country} from "../../../../business/interfaces/Country";
import {CountryFilterData} from "../../../../business/classes/CountryFilterData";
import {
  ColumnFilterType, SortDirection,
} from "../../../../components/table-view/table-view.component";
import {CountryNameId} from "../../../../business/name-id/CountryNameId";
import {ListCountriesResponse} from "../../../../business/interfaces/response-pagination/ListCountriesResponse";
import {OptionSelect} from "../../../../components/filters/enum/filter-type";
import {ErrorHandling} from "../../../../common/classes/ErrorHandling";
import {FormGroup, ValidatorFn} from "@angular/forms";
import {isString} from "../../../../common/utilities/General";

@Component({
  selector: 'country-search-text-field',
  templateUrl: './country-search-text-field.component.html',
  styleUrls: ['./country-search-text-field.component.css']
})
export class CountrySearchTextFieldComponent {

  @Input() loadData?: BehaviorSubject<any>;
  @Input() validators: ValidatorFn[] = [];
  @Input() id!: string;
  @Input() errorHandling: ErrorHandling | null = null;
  @Input() group!: FormGroup;

  @Output() onchange: EventEmitter<any> = new EventEmitter<any>();

  loadInputData: BehaviorSubject<[any, any]>;
  listData: Country[] = [];
  selected: Country | null = null;

  isLoading = false

  constructor(
    private countryApi: CountryAPI,
  ) {
    this.loadInputData = new BehaviorSubject<[any, any]>([[], null]);
  }

  ngOnInit(): void {
    this.loadData?.subscribe((data) => {
      if (isString(data)) {
        this.getCountryById(data)
      }
    });
    this.reloadDataSource("");
  }

  ngOnDestroy(): void {

  }

  updateCountrySelected(data:any){
    if (isString(data)) {
      this.getCountryById(data)
    }
  }

  getCountryById(id: string){
    if(id.hasActualValue()){
      this.countryApi
        .getDetails({countryId: id})
        .subscribe({
          next: (item: Country) => {
            this.selected = item
            this.reloadView()
          },
          error: (error: any) => {
            // Handle error
            console.error("Error:", error);
          },
        });
    }
  }

  reloadDataSource(search: string) {
    let columnInfo = {
      columId: CountryNameId.NAME_EN,
      name: "",
      filterType: ColumnFilterType.noun,
    }

    let sortField = {
      tableColumnInfo: columnInfo,
      direction: SortDirection.desc,
    }

    let filterMetaData = {
      itemsPerPage: 100,
      currentPage: 1,
    }

    let filterFieldTable = {
      tableColumnInfo: columnInfo,
      value: search
    }

    let filter = new CountryFilterData();
    filter.filterFieldTable = search.hasActualValue() ? [filterFieldTable] : [];
    filter.filterMetaData = filterMetaData;
    filter.sortField = sortField;

    this.isLoading = true;

    this.countryApi.getList(filter).subscribe({
      next: (response: ListCountriesResponse) => {
        this.isLoading = false;
        this.listData = response.data;
        this.reloadView();
      },
      error: (error: any) => {
        // Handle error
        this.isLoading = false;
        console.error("Error:", error);
      },
    });
  }

  onInputChange(event: any): void {
    const selectedValue = event as OptionSelect;
    let value = selectedValue.value
    this.selected = value
    this.onchange.emit(value);
  }

  onSearchChanged(event: any): void {
    // const text = (event.target as HTMLSelectElement).value;
    this.reloadDataSource(event)

  }

  private reloadView() {
    let optionSelected : OptionSelect | null = null
    let list: OptionSelect[] = this.listData.map(item => {
      return {
        value: item,
        label: item.nameEn,
      };
    });

    if(this.selected){
      optionSelected = {
        value: this.selected,
        label: this.selected.nameEn,

      }

      setTimeout(() => {
        this.onchange.emit(this.selected);
      }, 200);
    }
    this.loadInputData?.next([list, optionSelected]);
  }

}
